import type { OrderExercise } from '../../core/exercises.ts';

/** Builds a sentence from shuffled tiles; `order` holds tile indexes in the built order. */
export function OrderView({
  exercise,
  order,
  onChange,
  checked,
  correct,
}: {
  exercise: OrderExercise;
  order: number[];
  onChange: (value: number[]) => void;
  checked: boolean;
  correct: boolean;
}) {
  const renderTile = (index: number, onClick: () => void, disabled: boolean) => {
    const tile = exercise.tiles[index]!;
    return (
      <button key={index} type="button" className="tile" onClick={onClick} disabled={disabled}>
        <span className="tile__text han">{tile.surface}</span>
      </button>
    );
  };
  return (
    <div className="stack stack--24">
      <p className="prompt prompt--source">{exercise.promptRu}</p>
      <div
        className={`answer-line${checked ? (correct ? ' answer-line--correct' : ' answer-line--wrong') : ''}`}
        aria-label="Ваше предложение"
      >
        {order.map((index) => renderTile(index, () => onChange(order.filter((i) => i !== index)), checked))}
      </div>
      <div className="bank" aria-label="Слова">
        {exercise.tiles.map((_, index) =>
          order.includes(index) ? (
            <span key={index} className="tile tile--placeholder" aria-hidden="true" />
          ) : (
            renderTile(index, () => onChange([...order, index]), checked)
          ),
        )}
      </div>
    </div>
  );
}
